/* eslint-disable max-depth */
/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
// import { Builders, DataInstance, Trips } from "../..";
import { CollectionEntity } from "@busy-human/gearbox";
import { BuilderRecord, Builders } from "../../index.js";
import { Trips } from "../Trips/index.js";
import { cloneDeep, flatten } from 'lodash-es';
/**
     * Shuffles an array in-place
     * @param array Array to shuffle
     */
function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
}
export var Lottery;
(function (Lottery) {
    let LotteryAssignmentStatus;
    (function (LotteryAssignmentStatus) {
        LotteryAssignmentStatus["Unassigned"] = "unassigned";
        LotteryAssignmentStatus["Assigned"] = "assigned";
        LotteryAssignmentStatus["Pending"] = "pending";
    })(LotteryAssignmentStatus = Lottery.LotteryAssignmentStatus || (Lottery.LotteryAssignmentStatus = {}));
    // tiktok voice: I Love Magic Numbers!
    const NINETEEN = 19;
    const EIGHTEEN = 18;
    const SEVENTEEN = 17;
    const SIXTEEN = 16;
    const FIFTEEN = 15;
    const FOURTEEN = 14;
    let Group;
    (function (Group) {
        Group[Group["ParentGroups"] = 0] = "ParentGroups";
        Group[Group["Age19"] = 19] = "Age19";
        Group[Group["Age18"] = 18] = "Age18";
        Group[Group["Age17"] = 17] = "Age17";
        Group[Group["Age16"] = 16] = "Age16";
        Group[Group["Age15"] = 15] = "Age15";
        Group[Group["Age14"] = 14] = "Age14";
        Group[Group["Waitlisted"] = 1] = "Waitlisted";
    })(Group = Lottery.Group || (Lottery.Group = {}));
    function filterBuilderForGroup(builder, record, group, ageDate = new Date()) {
        switch (group) {
            case Group.ParentGroups: return record.builderTypeDetails.goingAsPair;
            case Group.Waitlisted: return !!record.onWaitlist;
            default: return (Builders.GetBuilderAge(builder.birthday, ageDate) === group && !record.builderTypeDetails.goingAsPair);
        }
    }
    Lottery.filterBuilderForGroup = filterBuilderForGroup;
    /**
     * Performs a lottery
     *! Does not verify if a booking is ready for the lottery
     *! Does not actually book users or anything
     * @param season Season for this lottery
     * @param records List of builderRecords to assign
     * @param builders Map of ids to builders
     * @param trips Map of ids to trips
     * @param destinations Map of ids to destinations
     */
    // eslint-disable-next-line max-params
    function prepareLottery(season, records, builders, trips, destinations, options) {
        const log = [];
        const nowMS = Date.now();
        const now = new Date(nowMS).toISOString();
        const assignments = [];
        const tripChangeSet = new Set();
        // Remove invalid records
        let builderQueue = records.filter((r) => {
            // Disallow reassigning trips
            if (r.tripAssigned && !options?.ignoreAssignments)
                return false;
            return true;
        });
        /** All trips which have been requested */
        const requestedTripSet = new Set(flatten(builderQueue.map(r => r.preferences)));
        /** Tracking trip availability. We only care about <slot>.spots in this function, we'll have a task queue recalculate counts later */
        const tripAvailability = [...trips.values()].reduce((arr, trip) => {
            // Trip has been requested
            if (requestedTripSet.has(trip.$id)
                // Trip starts in the future
                && new Date(trip.startDate).getTime() > nowMS
                // Trip has slots available (maybe omit this check?)
                && Trips.IsSlotAvailable(trip)) {
                arr[trip.$id] = cloneDeep(trip.groups);
            }
            return arr;
        }, {});
        /** Shuffle builders */
        const unbookedSet = new Set(builderQueue.map(b => b.$id));
        shuffle(builderQueue);
        /// Perform lottery
        // Start with first preference
        for (let prefNum = 0; prefNum < BuilderRecord.PREFERENCE_LIMIT; prefNum++) {
            // Go through every builder in the queue
            for (const builder of builderQueue) {
                // If the builders contact is blacklisted, skip
                if (builders.get(builder.$id)?.blacklisted) {
                    log.push(`Builder ${builders.get(builder.$id)?.name} (${builder.$id}) is a blacklisted contact and cannot be assigned via the lottery`);
                    continue;
                }
                // If the builder has already been booked, skip
                if (!unbookedSet.has(builder.$id)) {
                    if (options?.verbose)
                        log.push(`Builder ${builders.get(builder.$id)?.name} (${builder.$id}) has already been booked`);
                    continue;
                }
                ;
                // Deduce the parent and child
                let parent;
                let child;
                if (builder.builderTypeDetails.pairUser && builder.builderTypeDetails.goingAsPair) {
                    const pairRecord = records.find(r => r.$id === builder.builderTypeDetails.pairUser);
                    const pairBuilder = builders.get(builder.builderTypeDetails.pairUser);
                    // Don't include the other if they aren't in this lottery
                    if (!pairRecord && pairBuilder) {
                        log.push(`Builder ${builders.get(builder.$id)?.name.fullName} (${builder.$id}) paired with ${pairBuilder.name.fullName} (${builder.builderTypeDetails.pairUser}) but the latter isn't in this lottery`);
                        continue;
                    }
                    // Don't include the other if they don't exist
                    if (!pairRecord) {
                        log.push(`Builder ${builders.get(builder.$id)?.name.fullName} (${builder.$id}) is paired with (${builder.builderTypeDetails.pairUser}), but pair either doesn't exist or is not qualified for lottery`);
                        continue;
                    }
                    // Log if they aren't actually paired
                    if (pairRecord.builderTypeDetails.pairUser !== builder.$id) {
                        log.push(`Builder ${builders.get(builder.$id)?.name.fullName} (${builder.$id}) specifies pair with ${builders.get(pairRecord.$id)?.name.fullName} (${builder.builderTypeDetails.pairUser}) but latter does not say the same`);
                    }
                    if (pairBuilder?.blacklisted) {
                        log.push(`Builder ${builders.get(builder.$id)?.name} (${builder.$id}) paired with ${pairBuilder.name.fullName} (${builder.builderTypeDetails.pairUser}) but the latter is a blacklisted contact and cannot be assigned via the lottery`);
                        continue;
                    }
                    // Actually deduce the pair
                    if (builder.builderType === Builders.BuilderType.ParentBuilder) {
                        parent = builder;
                        child = pairRecord;
                    }
                    else {
                        parent = pairRecord;
                        child = builder;
                    }
                }
                else if (builder.builderType === Builders.BuilderType.ParentBuilder) {
                    parent = builder;
                }
                else {
                    child = builder;
                }
                // Get the builder data
                const parentData = builders.get(parent?.$id || "");
                const childData = builders.get(child?.$id || "");
                if (options?.verbose) {
                    if (parentData)
                        log.push(`Parent: ${parentData.name.fullName} (${parent?.$id})`);
                    if (childData)
                        log.push(`Child: ${childData.name.fullName} (${child?.$id})`);
                }
                // Deduce slots
                // Parent slot is simply parent_gender, if they are given
                const parentSlot = parentData ? `parent_${parentData.gender}` : null;
                // Youth slot depends on if they're in a duo or not
                // - Duos will always be hidden_duo
                // - Otherwise, teen_gender
                // eslint-disable-next-line no-nested-ternary
                const youthSlot = parentData
                    ? (childData ? "hidden_duo" : null)
                    : (childData ? `teen_${childData.gender}` : null);
                if (options?.verbose) {
                    if (parentSlot)
                        log.push(`Parent Slot: ${parentSlot}`);
                    if (youthSlot)
                        log.push(`Child Slot: ${youthSlot}`);
                }
                // Get their choices
                // Choice is always child first, then parent
                const choiceId = child?.preferences[prefNum] || parent?.preferences[prefNum];
                // If they don't have a preference for this number, skip
                if (!choiceId) {
                    if (options?.verbose)
                        log.push(`No choice for preference ${prefNum} given`);
                    continue;
                }
                ;
                // Get the trip info
                const choice = trips.get(choiceId);
                // If the trip doesn't exist, skip
                if (!choice) {
                    if (options?.verbose)
                        log.push(`Trip ${choiceId} doesn't exist`);
                    continue;
                }
                // Get the destination for the trip
                const destination = destinations.get(choice.destination);
                // If the destination doesn't exist, skip
                if (!destination) {
                    if (options?.verbose)
                        log.push(`Destination ${choice.destination}`);
                    continue;
                }
                ;
                // Check qualified
                if (parentData && !Builders.IsBuilderAllowedInSlot(parentData, choice, destination, false)) {
                    if (options?.verbose)
                        log.push(`Parent is not qualified for ${choice.name}`);
                    continue;
                }
                ;
                if (childData && !Builders.IsBuilderAllowedInSlot(childData, choice, destination, false)) {
                    if (options?.verbose)
                        log.push(`Child is not qualified for ${choice.name}`);
                    continue;
                }
                ;
                // Check spots available
                if (parentSlot && !tripAvailability[choiceId]?.[parentSlot]?.spots) {
                    if (options?.verbose)
                        log.push(`${choice.name} has no slots available for ${parentSlot}`);
                    continue;
                }
                ;
                if (youthSlot && !tripAvailability[choiceId]?.[youthSlot]?.spots) {
                    if (options?.verbose)
                        log.push(`${choice.name} has no slots available for ${youthSlot}`);
                    continue;
                }
                // If the parent exists and has an id in zoho
                if (parent && parentSlot && parentData && parent.zohoBuilderId) {
                    assignments.push({
                        builderId: parent.$id,
                        builderName: parentData.name.fullName || "",
                        builderZohoId: parent.zohoBuilderId,
                        builderType: Builders.BuilderType.ParentBuilder,
                        builderGroup: parentSlot,
                        builderBirthday: parentData.birthday,
                        tripId: choice.$id,
                        tripName: choice.name,
                        assignmentStatus: LotteryAssignmentStatus.Unassigned
                    });
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    tripAvailability[choiceId][parentSlot].spots -= 1;
                    // Mark them as 'booked'
                    unbookedSet.delete(parent.$id);
                    if (options?.verbose)
                        log.push(`${parentData.name.fullName} set to ${choice.name} (choice ${prefNum})`);
                }
                // If the child exists and has an id in zoho
                if (child && youthSlot && childData && child.zohoBuilderId) {
                    assignments.push({
                        builderId: child.$id,
                        builderName: childData.name.fullName || "",
                        builderZohoId: child.zohoBuilderId,
                        builderType: Builders.BuilderType.Builder,
                        builderGroup: youthSlot,
                        builderBirthday: childData.birthday,
                        tripId: choice.$id,
                        tripName: choice.name,
                        assignmentStatus: LotteryAssignmentStatus.Unassigned
                    });
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    tripAvailability[choiceId][youthSlot].spots -= 1;
                    // Mark them as 'booked'
                    unbookedSet.delete(child.$id);
                    if (options?.verbose)
                        log.push(`${childData.name.fullName} set to ${choice.name} (choice ${prefNum})`);
                }
                // Mark the trip as having been changed
                tripChangeSet.add(choiceId);
            }
            // Filter queue to just those who are unbooked
            builderQueue = builderQueue.filter(b => unbookedSet.has(b.$id));
        }
        // Everyone who didn't get booked will get waitlisted
        const waitlist = builderQueue.map(b => ({
            builderId: b.$id,
            builderZohoId: b.zohoBuilderId || "",
            builderName: builders.get(b.$id)?.name.fullName || "",
            builderType: b.builderType,
            builderBirthday: builders.get(b.$id)?.birthday || ""
        }));
        return {
            assignments,
            season,
            createdAt: now,
            trips: [...tripChangeSet].map((t) => {
                const trip = trips.get(t);
                const dest = destinations.get(trip?.destination || "");
                return {
                    id: t,
                    name: trip?.name || "",
                    price: dest?.price || null,
                    due: trip?.startDate || null
                };
            }),
            log: [...new Set(log).values()],
            waitlist,
        };
    }
    Lottery.prepareLottery = prepareLottery;
    function Default() {
        return {
            assignments: [],
            season: "",
            createdAt: new Date().toISOString(),
            trips: [],
            log: [],
            waitlist: [],
            allowedUsers: [],
            accessSecret: "",
            stage: "none",
            running: false,
            completed: false,
            progress: 0,
            groups: []
        };
    }
    Lottery.Default = Default;
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults() {
            return Default();
        }
    }
    Lottery.CollectionClass = CollectionClass;
    Lottery.Collection = new CollectionClass({ path: "/Lottery" });
})(Lottery || (Lottery = {}));
//# sourceMappingURL=index.js.map